<template>
  <el-tree
    :data="dataInfo.dataList"
    :props="dataInfo.dataSetting"
    :highlight-current="true"
    :default-expand-all="false"
    :expand-on-click-node="false"
    @node-click="handleNodeClick"
  >
  </el-tree>
</template>

<script>
export default {
  props: {
    dataInfo: {
      type: Object,
      default: function () {
        return {
          dataSetting: {
            children: "children",
            label: "label",
          },
          dataList: [],
        };
      },
    },
  },
  methods: {
    handleNodeClick(data) {
      this.$emit("handleNodeClick", { ...data });
    },
  },
};
</script>

<style lang="less" scoped>
@import url("./tree.scss");
</style>